import { camelCase } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Checkbox, IconButton, TableCell, TableRow, TextField } from '@material-ui/core';
import { DeleteOutlined as DeleteOutlinedIcon } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { schemaDataTypes } from './schemaDataTypes';
const StyledTableRow = styled(TableRow) `
  vertical-align: top;
  .MuiTableCell-root {
    padding: 12px 8px;
  }
  .column-type {
    min-width: 180px;
  }
`;
export const FormSchemaEditorRow = ({ column: initialColumn, onChange, onDelete, onError }) => {
    var _a, _b;
    const [column, setColumn] = useState(initialColumn);
    useEffect(() => {
        setColumn(initialColumn);
    }, [initialColumn]);
    const [error, setError] = useState({});
    const validateSchema = useCallback(() => {
        var _a, _b;
        // validate schema
        error.displayName = {
            touched: true,
            message: (column === null || column === void 0 ? void 0 : column.displayName.trim().length) === 0
                ? 'Field name is required'
                : ['id', 'modified', 'created'].includes(column === null || column === void 0 ? void 0 : column.displayName.trim().toLowerCase())
                    ? 'Field name is reserved by the system.'
                    : undefined
        };
        error.type = {
            touched: true,
            message: !(column === null || column === void 0 ? void 0 : column.type) || (column === null || column === void 0 ? void 0 : column.type).trim().length === 0
                ? 'Field type is required'
                : undefined
        };
        setError(Object.assign({}, error));
        return Boolean(!((_a = error.displayName) === null || _a === void 0 ? void 0 : _a.message) && !((_b = error.type) === null || _b === void 0 ? void 0 : _b.message));
    }, [column, error]);
    const handleColumnChange = useCallback((column) => {
        setColumn(Object.assign({}, column));
        if (validateSchema()) {
            onChange === null || onChange === void 0 ? void 0 : onChange(column);
        }
        else {
            onError === null || onError === void 0 ? void 0 : onError(error);
        }
    }, [error, onChange, onError, validateSchema]);
    return (React.createElement(StyledTableRow, null,
        React.createElement(TableCell, null,
            React.createElement(TextField, { fullWidth: true, size: 'small', variant: 'outlined', placeholder: 'Field Name', value: column.displayName, error: Boolean((_a = error.displayName) === null || _a === void 0 ? void 0 : _a.message), helperText: (_b = error.displayName) === null || _b === void 0 ? void 0 : _b.message, onChange: event => {
                    column.displayName = event.target.value;
                    handleColumnChange(column);
                } })),
        React.createElement(TableCell, null,
            React.createElement(TextField, { fullWidth: true, disabled: true, size: 'small', variant: 'outlined', placeholder: 'Property Key', value: camelCase(column.displayName) })),
        React.createElement(TableCell, { className: 'column-type' },
            React.createElement(Autocomplete, { freeSolo: true, forcePopupIcon: true, options: schemaDataTypes, renderInput: params => {
                    var _a, _b;
                    return (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', error: Boolean((_a = error.type) === null || _a === void 0 ? void 0 : _a.message), helperText: (_b = error.type) === null || _b === void 0 ? void 0 : _b.message })));
                }, value: column.type, onChange: (_, value) => {
                    handleColumnChange(Object.assign(Object.assign({}, column), { type: value }));
                } })),
        React.createElement(TableCell, { className: 'column-array' },
            React.createElement(Checkbox, { size: 'small', color: 'primary', checked: Boolean(column.array), onChange: event => {
                    column.array = event.target.checked;
                    handleColumnChange(column);
                } })),
        React.createElement(TableCell, { className: 'comment input-column' },
            React.createElement(TextField, { fullWidth: true, size: 'small', variant: 'outlined', autoComplete: 'off', placeholder: 'Add a description.', value: column.comment || '', onChange: event => {
                    column.comment = event.target.value;
                    handleColumnChange(column);
                } })),
        React.createElement(TableCell, null,
            React.createElement(IconButton, { size: 'small', onClick: () => {
                    onDelete === null || onDelete === void 0 ? void 0 : onDelete(column);
                } },
                React.createElement(DeleteOutlinedIcon, null)))));
};
export default FormSchemaEditorRow;
//# sourceMappingURL=FormSchemaEditorRow.js.map